export const SET_FILTERED_LIST = "WORKERS/SET_FILTERED_LIST";
export const RESET_FILTERED_LIST = "WORKERS/RESET_FILTERED_LIST";
export const LOAD_USERS = "WORKERS/LOAD_USERS";
export const SET_LOADING = "WORKERS/SET_LOADING";
export const SET_SKELETON = "WORKERS/SET_SKELETON";
export const SET_WORKER = "WORKERS/SET_WORKER";
